import { useQuery } from '@tanstack/react-query';
import { OutreachProgram } from '../types/outreach';

interface UseProgramsOptions {
  search?: string;
  status?: string;
  type?: string;
}

async function fetchPrograms(_options: UseProgramsOptions = {}): Promise<OutreachProgram[]> {
  // Simulate API call
  await new Promise(resolve => setTimeout(resolve, 1000));

  return [
    {
      id: '1',
      name: 'Community Health Screening',
      description: 'Free health screenings for the local community',
      startDate: '2024-03-20',
      endDate: '2024-03-22',
      location: {
        name: 'Community Center',
        address: '123 Main St',
        coordinates: { lat: 40.7128, lng: -74.0060 },
      },
      status: 'active',
      type: 'health-screening',
      targetParticipants: 200,
      actualParticipants: 150,
      staff: [
        { id: '1', name: 'Dr. Smith', role: 'Lead Doctor' },
        { id: '2', name: 'Nurse Johnson', role: 'Nurse' },
      ],
      metrics: {
        patientsServed: 150,
        servicesProvided: 300,
        satisfactionRate: 95,
      },
    },
    // Add more mock programs...
  ];
}

export function usePrograms(options: UseProgramsOptions = {}) {
  return useQuery({
    queryKey: ['outreach-programs', options],
    queryFn: () => fetchPrograms(options),
  });
}